import api from "../axios/api";
import { IPayload } from "../models/ipayload";
import Axios from "axios";
import { IEquipmentGroup } from "../models/iequipmentGroup";
let CancelToken = Axios.CancelToken;
let fetchGroupsServices_cancel: any


export const fetchGroupsServices = (page: number, limit: number, search: string, order: string, orderBy: string, documenttypeId: string): Promise<IPayload<IEquipmentGroup>> => {
    fetchGroupsServices_cancel && fetchGroupsServices_cancel()

    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}${documenttypeId ? `&documenttype=${documenttypeId}` : ''}`;
    return api.get('/equipmentGroups' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchGroupsServices_cancel = c;
      })
    })
}

